<template>
  <div v-if="rendered"
       class="data-grid-dialog">
    <el-dialog v-el-drag-dialog
               :append-to-body="true"
               :close-on-click-modal="false"
               :visible.sync="isShow"
               :fullscreen="isFullscreen"
               v-bind="$attrs"
               v-on="dialogListeners">
      <template slot="title">
        <template v-if="$slots.title">
          <slot name="title"></slot>
        </template>
        <template v-else>
          <span class="el-dialog__title">{{ $attrs.title }}</span>
          <template v-if="useFullscreen">
            <i :class="['el-dialog__fullscreenbtn', isFullscreen ? 'el-icon-copy-document' : 'el-icon-full-screen']"
               @click="toggleFullscreen"></i>
          </template>
        </template>
      </template>
      <slot></slot>
      <template v-if="$slots.footer"
                slot="footer">
        <slot name="footer"></slot>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import elDragDialog from '../../../directive/elDialogDrag'
import PopperBus from '../../../mixins/popper/bus'
import PopperDecorator from '../../../mixins/popper/decorator'
export default {
  name: 'DataGridDialog',
  mixins: [PopperBus, PopperDecorator],
  directives: {elDragDialog},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    useFullscreen: {
      type: Boolean,
      default: false
    }
  },
  provide () {
    return {
      $popper: this
    }
  },
  data () {
    return {
      rendered: false,
      isShow: false,
      isFullscreen: false
    }
  },
  computed: {
    dialogListeners () {
      return this.$extend(this.$listeners, {
        open: this.openEvent,
        opened: this.openedEvent,
        close: this.closeEvent,
        closed: this.closedEvent
      })
    }
  },
  methods: {
    initialDialog () {
      if (this.visible && !this.rendered) {
        this.rendered = true
      }
      this.$nextTick(() => {
        this.isShow = this.visible
      })
    },
    toggleFullscreen () {
      this.isFullscreen = !this.isFullscreen
    }
  },
  mounted () {
    this.initialDialog()
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.rendered = true
      }
      this.$nextTick(() => {
        this.isShow = val
      })
    },
    isShow: function (val) {
      this.$emit('update:visible', val)
    }
  }
}
</script>
